import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cd954f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "home_main"
}
const _hoisted_3 = { class: "home_invest_info" }
const _hoisted_4 = { class: "home_invest_content" }
const _hoisted_5 = { class: "title_18B" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("님의 추정 평가금액 ")
const _hoisted_7 = { class: "home_info" }
const _hoisted_8 = { class: "large strong" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "large" }, " 원 ", -1))
const _hoisted_10 = { class: "home__invest_detail space-between" }
const _hoisted_11 = {
  key: 0,
  class: "invest_status red"
}
const _hoisted_12 = { class: "num_14BK" }
const _hoisted_13 = {
  key: 1,
  class: "invest_status gray"
}
const _hoisted_14 = { class: "num_14BK" }
const _hoisted_15 = {
  key: 2,
  class: "invest_status sky"
}
const _hoisted_16 = { class: "num_14BK" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray main_14R" }, "더보기", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!

  return (_ctx.user === null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_ctx.assetPartnerships && _ctx.assetPartnerships.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', direction: ['column', 'row']} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, { css: {typography: 'tit18r', grow: 1} }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text_s, { css: {typography: 'main12r', color: 'gray3'} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formattedDate(_ctx.reflectAt)) + " 시장가 기준 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(parseInt(_ctx.totalAsset) + parseInt(_ctx.totalIncomingProfit))), 1)
                ]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                (parseInt(_ctx.totalIncomingProfit) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, "+" + _toDisplayString(_ctx.$filters.currency(_ctx.totalIncomingProfit)), 1),
                      _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.toFixed(_ctx.totalIncomingProfitRate, 2))) + "%) ", 1)
                    ]))
                  : (parseInt(_ctx.totalIncomingProfit) === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$filters.currency(_ctx.totalIncomingProfit)), 1),
                        _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.toFixed(_ctx.totalIncomingProfitRate, 2))) + "%) ", 1)
                      ]))
                    : (parseInt(_ctx.totalIncomingProfit) < 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$filters.currency(_ctx.totalIncomingProfit)), 1),
                          _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.toFixed(_ctx.totalIncomingProfitRate, 2))) + "%) ", 1)
                        ]))
                      : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "invest_sort",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'개별 추정 평가금액', 'clickContent':'더보기'}); _ctx.router.push('/tabs/mypage/myasset')})
                }, _hoisted_19)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}